@if(mobileQuery.matches) {
<div class="horizontal-sidebar p-y-8 b-b-1">
  <div class="container">
    <div class="d-flex justify-content-between align-items-center">
      <div class="horizontal-navbar hstack align-items-center">
        @for(item of navItems; track item) {
        <app-horizontal-nav-item
          [item]="item"
          class="parentBox {{ item.ddType }}"
          [ngClass]="{
            pactive: item.route == parentActive ? 'pactive' : ''
          }"
        >
        </app-horizontal-nav-item>
        }
      </div>
      <div class="language-buttons">
        <button mat-button (click)="changeLanguage('tr')" [class.active]="currentLang === 'tr'">TR</button>
        <button mat-button (click)="changeLanguage('en')" [class.active]="currentLang === 'en'">EN</button>
        <button mat-button (click)="changeLanguage('de')" [class.active]="currentLang === 'de'">DE</button>
      </div>
    </div>
  </div>
</div>
}
